import React from "react";
import { Box, Typography } from "@mui/material";

const PreAuthShell = ({
  title,
  subtitle,
  children,
  footer,
  maxWidth = 460,
  surfaceSx = {},
}) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(180deg, #f7f4fb 0%, #ffffff 52%, #f2eef9 100%)",
        fontFamily: "Roboto, Arial, sans-serif",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            width: 220,
            height: 220,
            top: -80,
            right: -40,
            borderRadius: "999px",
            background: "radial-gradient(circle, rgba(92, 59, 139, 0.18) 0%, rgba(92, 59, 139, 0) 70%)",
            opacity: 0.75,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            width: 260,
            height: 260,
            left: -120,
            bottom: 40,
            borderRadius: "999px",
            background: "radial-gradient(circle, rgba(92, 59, 139, 0.18) 0%, rgba(92, 59, 139, 0) 70%)",
            opacity: 0.75,
          }}
        />
      </Box>

      <Box
        sx={{
          position: "relative",
          maxWidth,
          width: "100%",
          boxSizing: "border-box",
          mx: "auto",
          px: { xs: 2, sm: 2.5 },
          pt: 2.5,
          pb: "calc(env(safe-area-inset-bottom) + 24px)",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", color: "#492099", fontWeight: 600, fontSize: 20, marginLeft: "-4px" }}>
          <img src="/logo2-removebg-preview.png" alt="NoteRefinery logo" style={{ width: 42, height: 42, marginRight: 0 }} />
          <span style={{ marginTop: 6 }}>NoteRefinery</span>
        </Box>

        {title ? (
          <Typography sx={{ fontSize: 30, lineHeight: 1.15, fontWeight: 600, color: "#2b2140", mt: 0.5 }}>
            {title}
          </Typography>
        ) : null}
        {subtitle ? (
          <Typography sx={{ fontSize: 14, color: "#5a4a7b", mt: -0.5 }}>
            {subtitle}
          </Typography>
        ) : null}

        <Box
          sx={{
            background: "#fff",
            borderRadius: 3,
            border: "1px solid rgba(73, 32, 153, 0.08)",
            boxShadow: "0 16px 26px rgba(73, 32, 153, 0.08)",
            p: 2,
            ...surfaceSx,
          }}
        >
          {children}
        </Box>

        {footer ? <Box>{footer}</Box> : null}
      </Box>
    </Box>
  );
};

export default PreAuthShell;
